import * as normalize from 'utils/normalize';

import getInsuranceID from 'utils/print/getInsuranceID';
import getPatientFirstName from 'utils/print/getPatientFirstName';
import getPatientLastName from 'utils/print/getPatientLastName';
import getOtherInsuranceID from 'utils/print/getOtherInsuranceID';
import getPatientFullPhone from 'utils/print/getPatientFullPhone';
import getPatientFullDob from 'utils/print/getPatientFullDob';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getPrescriberFirstName from 'utils/print/getPrescriberFirstName';
import getPrescriberLastName from 'utils/print/getPrescriberLastName';
import getPrescriberAddress from 'utils/print/getPrescriberAddress';
import getPrescriberCityState from 'utils/print/getPrescriberCityState';
import getPrescriberZip from 'utils/print/getPrescriberZip';
import getPrescriberFullPhone from 'utils/print/getPrescriberFullPhone';
import getPrescriberFullFax from 'utils/print/getPrescriberFullFax';
import getSupplierNSCorNPI from 'utils/print/getSupplierNSCorNPI';
import getInquiringProviderUserFirstName from 'utils/print/getInquiringProviderUserFirstName';
import getInquiringProviderUserLastName from 'utils/print/getInquiringProviderUserLastName';
import getSupplierFullPhone from 'utils/print/getSupplierFullPhone';
import getSupplierFullFax from 'utils/print/getSupplierFullFax';
import getFacilityStreet from 'utils/print/getFacilityStreet';
import getFacilityZip from 'utils/print/getFacilityZip';
import getFacilityCityState from 'utils/print/getFacilityCityState';
import getOrderLineDosFrom1 from 'utils/print/getOrderLineDosFrom1';
import getOrderLineDosFrom2 from 'utils/print/getOrderLineDosFrom2';
import getOrderLineDosFrom3 from 'utils/print/getOrderLineDosFrom3';
import getOrderLineDosTo1 from 'utils/print/getOrderLineDosTo1';
import getOrderLineDosTo2 from 'utils/print/getOrderLineDosTo2';
import getOrderLineDosTo3 from 'utils/print/getOrderLineDosTo3';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineUnits from 'utils/print/getOrderLineUnits';
import getOrderLineDescription from 'utils/print/getOrderLineDescription';
import getOrderLineTotalCharge from 'utils/print/getOrderLineTotalCharge';

const PriorAuthorizationTemplateWellcareAuthorizationRequest = {
  ID: 26,
  Name: 'Wellcare Authorization Request',
  Type: 'Prior Authorization Template',
  Format: 'letter',
  Orientation: 'p',
  OrderLineMax: 6,
  WithCharge: true,
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Prior-Authorization-Template-Wellcare-Authorization-Request/1.js',
      fields: [
        {
          name: 'DME',
          type: 'checkbox',
          x: 58,
          y: 42.5,
          width: 3,
          height: 3,
        },
        {
          name: 'Transition of Care',
          type: 'checkbox',
          x: 118.5,
          y: 42.5,
          width: 3,
          height: 3,
        },
        {
          name: 'POINT OF SERVICE BENEFIT OPTION ELECTED BY MEMBER',
          type: 'checkbox',
          x: 43,
          y: 47.5,
          width: 2,
          height: 2,
        },
        {
          name: 'Member WellCare ID',
          type: 'text',
          getValue: getInsuranceID,
          x: 27,
          y: 71.5,
          width: 47,
        },
        {
          name: 'Member Last Name',
          type: 'text',
          getValue: getPatientLastName,
          x: 95,
          y: 71.5,
          width: 52,
        },
        {
          name: 'Member First Name',
          type: 'text',
          getValue: getPatientFirstName,
          x: 174,
          y: 71.5,
          width: 36,
        },
        {
          name: 'Member Medicaid/Medicare ID',
          type: 'text',
          getValue: getOtherInsuranceID,
          x: 42,
          y: 77.5,
          width: 32,
        },
        {
          name: 'Member Phone Number',
          type: 'text',
          getValue: getPatientFullPhone,
          x: 102,
          y: 77.5,
          width: 45,
        },
        {
          name: 'Member Date of Birth',
          type: 'text',
          getValue: getPatientFullDob,
          x: 174,
          y: 77.5,
          width: 36,
          normalize: normalize.date,
        },
        {
          name: 'ORDERING PROVIDER WellCare ID Number',
          type: 'text',
          x: 38,
          y: 89.5,
          width: 65,
        },
        {
          name: 'ORDERING PROVIDER NPI Number',
          type: 'text',
          getValue: getPrescriberNPI,
          x: 126,
          y: 89.5,
          width: 84,
        },
        {
          name: 'ORDERING PROVIDER Last Name',
          type: 'text',
          getValue: getPrescriberLastName,
          x: 25,
          y: 96,
          width: 78,
        },
        {
          name: 'ORDERING PROVIDER First Name',
          type: 'text',
          getValue: getPrescriberFirstName,
          x: 125,
          y: 96,
          width: 85,
        },
        {
          name: 'ORDERING PROVIDER Street Address',
          type: 'text',
          getValue: getPrescriberAddress,
          x: 30,
          y: 101,
          width: 73,
        },
        {
          name: 'ORDERING PROVIDER City State',
          type: 'text',
          getValue: getPrescriberCityState,
          x: 123,
          y: 101,
          width: 46,
        },
        {
          name: 'ORDERING PROVIDER Zip',
          type: 'text',
          getValue: getPrescriberZip,
          x: 186,
          y: 101,
          width: 24,
        },
        {
          name: 'ORDERING PROVIDER Phone Number',
          type: 'text',
          getValue: getPrescriberFullPhone,
          x: 30,
          y: 106.5,
          width: 73,
        },
        {
          name: 'ORDERING PROVIDER Fax Number',
          type: 'text',
          getValue: getPrescriberFullFax,
          x: 126,
          y: 106.5,
          width: 84,
        },
        {
          name: 'ORDERING PROVIDER Type/Specialty',
          type: 'text',
          x: 43,
          y: 113,
          width: 60,
        },
        {
          name: 'ORDERING PROVIDER Name of Requester',
          type: 'text',
          x: 138,
          y: 113,
          width: 72,
        },
        {
          name: 'Check this box to skip this section and have the Plan assign to the Provider / Vendor',
          type: 'checkbox',
          x: 7.5,
          y: 125.5,
          width: 3,
          height: 3,
        },
        {
          name: 'TREATING PROVIDER WellCare ID Number',
          type: 'text',
          x: 38,
          y: 132,
          width: 65,
        },
        {
          name: 'TREATING PROVIDER NPI Number',
          type: 'text',
          getValue: getSupplierNSCorNPI,
          x: 126,
          y: 132,
          width: 84,
        },
        {
          name: 'TREATING PROVIDER Last Name',
          type: 'text',
          getValue: getInquiringProviderUserLastName,
          x: 28,
          y: 137,
          width: 75,
        },
        {
          name: 'TREATING PROVIDER First Name',
          type: 'text',
          getValue: getInquiringProviderUserFirstName,
          x: 126,
          y: 137,
          width: 84,
        },
        {
          name: 'TREATING PROVIDER Street Address',
          type: 'text',
          getValue: getFacilityStreet,
          x: 30,
          y: 142,
          width: 73,
        },
        {
          name: 'TREATING PROVIDER City State',
          type: 'text',
          getValue: getFacilityCityState,
          x: 125,
          y: 142,
          width: 43,
        },
        {
          name: 'TREATING PROVIDER Zip',
          type: 'text',
          getValue: getFacilityZip,
          x: 186,
          y: 142,
          width: 24,
        },
        {
          name: 'TREATING PROVIDER Phone',
          type: 'text',
          getValue: getSupplierFullPhone,
          x: 31,
          y: 147.5,
          width: 72,
        },
        {
          name: 'TREATING PROVIDER Fax',
          type: 'text',
          getValue: getSupplierFullFax,
          x: 126,
          y: 147.5,
          width: 84,
        },
        {
          name: 'TREATING PROVIDER Type',
          type: 'text',
          x: 43,
          y: 152.5,
          width: 60,
        },
        {
          name: 'TREATING PROVIDER Name of Requester',
          type: 'text',
          x: 137,
          y: 152.5,
          width: 73,
        },
        {
          name: 'Facility Type',
          type: 'radio',
          options: [
            {
              x: 69,
              y: 163.5,
              width: 3,
              height: 3,
              value: 'Office',
            },
            {
              x: 132,
              y: 163.5,
              width: 3,
              height: 3,
              value: 'Home',
            },
          ],
        },
        {
          name: 'Planned Date of Service From 1',
          type: 'text',
          getValue: props => getOrderLineDosFrom1({ ...props, index: 0 }),
          x: 60,
          y: 174.5,
          width: 5,
          normalize: normalize.positiveNumber,
          maxLength: 2,
        },
        {
          name: 'Planned Date of Service From 2',
          type: 'text',
          getValue: props => getOrderLineDosFrom2({ ...props, index: 0 }),
          x: 67,
          y: 174.5,
          width: 5,
          normalize: normalize.positiveNumber,
          maxLength: 2,
        },
        {
          name: 'Planned Date of Service From 3',
          type: 'text',
          getValue: props => getOrderLineDosFrom3({ ...props, index: 0 }),
          x: 74,
          y: 174.5,
          width: 10,
          normalize: normalize.positiveNumber,
          maxLength: 4,
        },
        {
          name: 'Planned Date of Service To 1',
          type: 'text',
          getValue: props => getOrderLineDosTo1({ ...props, index: 0 }),
          x: 97,
          y: 174.5,
          width: 5,
          normalize: normalize.positiveNumber,
          maxLength: 2,
        },
        {
          name: 'Planned Date of Service To 2',
          type: 'text',
          getValue: props => getOrderLineDosTo2({ ...props, index: 0 }),
          x: 103,
          y: 174.5,
          width: 5,
          normalize: normalize.positiveNumber,
          maxLength: 2,
        },
        {
          name: 'Planned Date of Service To 3',
          type: 'text',
          getValue: props => getOrderLineDosTo3({ ...props, index: 0 }),
          x: 109,
          y: 174.5,
          width: 10,
          normalize: normalize.positiveNumber,
          maxLength: 4,
        },
        {
          name: 'Primary ICD-10 Code',
          type: 'text',
          getValue: getDiagnosisCode,
          x: 42,
          y: 179.5,
          width: 60,
        },
        {
          name: 'Primary ICD-10 Description',
          type: 'text',
          x: 131,
          y: 179.5,
          width: 80,
        },
        ...[0, 1, 2, 3, 4, 5].reduce((accumulator, currentValue) => {
          const y = 195 + (currentValue * 6.3);
          return [
            ...accumulator,
            {
              name: `HCPC Code ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineHCPCSCode({ ...props, index: currentValue }),
              x: 7,
              y,
              width: 48,
            },
            {
              name: `Service Description ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDescription({ ...props, index: currentValue }),
              x: 58,
              y,
              width: 49,
            },
            {
              name: `Units ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineUnits({ ...props, index: currentValue }),
              x: 110,
              y,
              width: 29,
              normalize: normalize.number,
            },
            {
              name: `Total Amount Billed ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineTotalCharge({ ...props, index: currentValue }),
              x: 162,
              y,
              width: 45,
              normalize: normalize.price,
              chargeField: true,
            },
          ];
        }, []),
        {
          name: 'Pertinent Clinical Summary 1',
          type: 'text',
          x: 7,
          y: 242.5,
          width: 203,
        },
        {
          name: 'Pertinent Clinical Summary 2',
          type: 'text',
          x: 7,
          y: 247,
          width: 203,
        },
      ],
    },
  ],
};

export default PriorAuthorizationTemplateWellcareAuthorizationRequest;



// WEBPACK FOOTER //
// ./src/config/documents/Prior-Authorization-Template-Wellcare-Authorization-Request.js